import { createSelector } from 'reselect';

import {
  activeItemSelector,
  featureSwitchesSelector,
  offsetTopSelector,
} from '@xingternal/platform-layout-selectors';

const layoutMainSelector = createSelector(
  activeItemSelector,
  featureSwitchesSelector,
  offsetTopSelector,
  (activeItem, featureSwitches, offsetTop) => {
    return {
      activeItem,
      featureSwitches,
      offsetTop,
    };
  }
);

export { layoutMainSelector };
